import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { IconTimesDefault } from '@iwoca/icons';
import { clsx } from 'clsx';

export const InfoSheet = ({
  isOpen,
  onClose,
  title,
  closeLabel,
  headerClassName,
  titleClassName,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  closeLabel: string;
  /** Overrides the header's default 24px padding. */
  headerClassName?: string;
  /** Overrides the title's default size. */
  titleClassName?: string;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;

  return (
    <Dialog open onClose={onClose} className="relative z-10">
      <div className="fixed inset-0 bg-primary-10/50" aria-hidden />
      <div className="fixed inset-0 flex items-center justify-center max-1024:items-end">
        <DialogPanel className="relative flex max-h-[85vh] w-full max-w-[600px] flex-col overflow-hidden rounded-l border border-secondary-90 bg-structure-100 shadow-blue-s max-1024:max-w-none max-1024:rounded-b-none max-1024:rounded-t-l">
          <div className={clsx('bg-secondary-95', headerClassName ?? 'p-xl')}>
            {/* Tailwind preflight is off, so the h2's UA margin has to go, and
                the close button is out of flow so the text needs room for it. */}
            <DialogTitle
              className={clsx(
                'm-0 pr-4xl font-bold text-primary-10',
                titleClassName ?? 'text-2xl',
              )}
            >
              {title}
            </DialogTitle>
            <button
              type="button"
              onClick={onClose}
              aria-label={closeLabel}
              // Inset plus padding puts the icon on the header's 24px padding
              // box while keeping a 40px tap target.
              className="absolute right-l top-l flex cursor-pointer border-none bg-transparent p-s text-primary-10"
            >
              <IconTimesDefault width={24} height={24} aria-hidden />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto">{children}</div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
